import dayjs from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
dayjs.extend(utc);
dayjs.extend(timezone);

export const businessEntityId = "263551a1-ff23-4e42-b813-69212f42e73e";

export const getLocalTime = (
  datetime: string,
  timezone: string = "America/Toronto"
): string => {
  return dayjs(datetime).tz(timezone).format("hh:mm A");
};

export const getLocalDate = (
  date: dayjs.Dayjs,
  timezone: string = "America/Toronto"
): dayjs.Dayjs => {
  return dayjs(date).tz(timezone);
};
